<template>
  <el-dialog title="知识库" :visible.sync="formVisible" :close-on-click-modal="false" top="3vh" width="800px">
    <div class="input-box">
      <el-input v-model="inputValue" placeholder="请输入问题" prefix-icon="el-icon-search"></el-input>
      <el-button type="primary" size="small" @click="getKnowledgeList">搜索</el-button>
    </div>
    <div class="content" :style="'height: ' + windowHeight + 'px; overflow-y: auto;'">
      <div class="ques-box">
        <ul class="list" v-for="(item,index) in knowledgeOptions" :key="index">
          <li><span>问题：</span>
            <div class="cont">{{item.title}}</div>
          </li>
          <li><span>回答：</span>
            <div class="cont">
              <p :class="{'active': it.active}" v-for="(it,idx) in item.contents" :key="idx" @click="handleContent(it,index)">{{it.content}}</p>
            </div>
          </li>
        </ul>
        <!-- <ul class="list">
          <li><span>问题：</span>
            <div class="cont">怎么充值金额</div>
          </li>
          <li><span>回答：</span>
            <div class="cont">请前往个人中心-余额账户-充值；选择需要充值金额即可。
          </li>
        </ul> -->
      </div>
       <el-empty description="暂无数据" v-if="!knowledgeOptions.length"></el-empty>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="doCreate()">确认</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import custServiceInfoLibraryApi from '@/api/customer/custServiceInfoLibrary'

export default {
  data() {
    return {
      form: null,
      formVisible: false,
      rowData: null,
      inputValue: '',
      knowledgeOptions: []
    }
  },
  created() {
    const windowHeight =
      window.innerHeight ||
      document.documentElement.clientHeight ||
      document.body.clientHeight;
    this.windowHeight = windowHeight - 200;

  },
  methods: {
    handleShow() {
      this.getKnowledgeList()
      this.formVisible = true;
    },
    getKnowledgeList() {
      custServiceInfoLibraryApi.fetchForList({ isGetContent: true, title: this.inputValue }).then(({ data }) => {
        let { list } = data;
        this.knowledgeOptions = list;
        this.$forceUpdate()
      })
    },
    handleContent(it) {
      this.rowData = it
      this.knowledgeOptions.forEach(ab => {
        ab.contents.forEach(cc => {
          cc.active = false;
        })
      })
      it.active = true;
      this.$forceUpdate()
    },
    doCreate() {
      this.$emit('created', this.rowData,15);
      this.formVisible = false
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body {
  padding: 10px 0;
}
.input-box {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  .el-button {
    margin: 0 10px;
  }
}
.ques-box {
  margin-bottom: 15px;
  padding: 0 20px;
  .list {
    list-style: none;
    padding-left: 0;
    background: #eff8fd;
    padding: 12px;
    border-radius: 10px;
    li {
      font-size: 14px;
      &:nth-child(1) {
        padding-bottom: 5px;
      }
      .cont {
        display: inline-block;
        vertical-align: top;
        p {
          margin: 0;
          padding-bottom: 5px;
          cursor: pointer;
          &.active {
            color: #1596cd;
          }
        }
      }
    }
  }
}
.dialog-footer {
  position: absolute;
  bottom: 5px;
  text-align: right;
  right: 20px;
}
::v-deep .date1 .el-input--prefix .el-input__inner {
  padding-left: 0;
}
/* 修改滚动条整体样式 */
::-webkit-scrollbar {
  width: 6px;
  /* 滚动条宽度 */
  background-color: #f1f1f1;
  /* 滚动条背景色 */
}

/* 修改滚动条滑块样式 */
::-webkit-scrollbar-thumb {
  background-color: #d2d2d2;
  /* 滑块颜色 */
  border-radius: 4px;
  /* 滑块圆角 */
}

/* 修改滚动条轨道样式 */
::-webkit-scrollbar-track {
  background-color: #f1f1f1;
  /* 轨道背景色 */
}

/* 修改滚动条角落样式 */
::-webkit-scrollbar-corner {
  background-color: #f1f1f1;
  /* 角落背景色 */
}
</style>
